import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Api from "./utils/apiCall";
import { API_URLS } from "./apis/urls";

interface AiChatState {
    sendMessageData: any;
    loading: "idle" | "pending" | "fulfilled" | "rejected";
    error: string | null;
    action: "send_message" | null;
}

const aiChatInitialState: AiChatState = {
    sendMessageData: null,
    loading: "idle",
    error: null,
    action: null,
};

export const sendChatMessage: any = createAsyncThunk(
    "aiChat/sendMessages",
    async (payload: any, thunkAPI) => {
        try {
            const wrappedPayload = {
                Header: {
                    device_type: "WEB",
                    device_id: "WEB",
                    "enc-req": false
                },
                Request: {
                    data: payload
                }
            };
            const response = await Api.post(
                API_URLS.AICHAT.SEND_MESSAGE,
                wrappedPayload,
                true
            );
            return response;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
        }
    }
);

const aiChatSlice = createSlice({
    name: "aiChat",
    initialState: aiChatInitialState,
    reducers: {
        resetAll: (state: any) => {
            state.loading = "idle";
            state.error = null;
            state.sendMessageData = null;
            state.action = null;
        },
        clearError: (state) => {
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(sendChatMessage.pending, (state) => {
            state.loading = "pending";
            state.sendMessageData = null;
            state.error = null;
            state.action = "send_message";
        });
        builder.addCase(sendChatMessage.fulfilled, (state, action) => {
            state.loading = "fulfilled";
            state.sendMessageData = action.payload;
            state.error = null;
            state.action = "send_message";
        });
        builder.addCase(sendChatMessage.rejected, (state, action) => {
            state.loading = "rejected";
            state.error = action.payload as string;
            state.sendMessageData = null;
            state.action = "send_message";
        });
    },
});

export const { resetAll, clearError } = aiChatSlice.actions;
export default aiChatSlice.reducer;

